import { MakeApiCall } from '../apis';
import { setPermissions as setPermissionsAction } from '../redux/actions';
import { persistor, store } from '../redux/store';
import { shouldSyncPermissionsOnLoad } from './permissions';

const isSuccessfulPermissionsResponse = (response) =>
  Boolean(response?.success || response?.status);

export const fetchStaffPermissions = async (token) => {
  if (!token) return null;

  const response = await MakeApiCall(
    `rbac/my-permissions?_=${Date.now()}`,
    'get',
    null,
    true,
    {},
    token,
    { skipAuthRedirect: true }
  );

  if (!isSuccessfulPermissionsResponse(response)) {
    return null;
  }

  const permissions = response?.data?.permissions || [];
  store.dispatch(setPermissionsAction(permissions));

  try {
    if (typeof persistor?.flush === 'function') {
      await persistor.flush();
    }
  } catch (error) {
    console.error('Failed to persist permissions:', error);
  }

  return permissions;
};

export const refreshStaffPermissions = async () => {
  const user = store.getState()?.user?.data;
  if (!user?.token || !shouldSyncPermissionsOnLoad(user)) {
    return null;
  }

  return fetchStaffPermissions(user.token);
};
